module.exports = __webpack_public_path__ + "static/bubble-hearth-dec6966844ab07a35a02db34291eb225.png";